// extracted by mini-css-extract-plugin
module.exports = {"dibsvg-svg":"_d33c4c5b"};